// extracted by mini-css-extract-plugin
module.exports =  {"visibilityDetector":"ChangeBuildTypeDetails__visibilityDetector--I8"};